import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2.5a7.5 7.5 0 100 15 7.5 7.5 0 000-15z",
      fill: "url(#loading-alt_svg__paint0_angular)"
    }
  ),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement(
    "radialGradient",
    {
      id: "loading-alt_svg__paint0_angular",
      cx: 0,
      cy: 0,
      r: 1,
      gradientUnits: "userSpaceOnUse",
      gradientTransform: "matrix(0 10 -10 0 12 12)"
    },
    /* @__PURE__ */ e.createElement("stop", { stopColor: "#1E41EB" }),
    /* @__PURE__ */ e.createElement("stop", { offset: 1, stopColor: "#1E41EB", stopOpacity: 0 })
  ))
), l = a;
export {
  l as default
};
